import { Grid, Typography } from '@mui/material';
import { styles } from './styles';

export const BadgeNoContent = ({
  heading,
  subheading,
}: {
  heading: string;
  subheading?: string;
}) => {
  return (
    <Grid sx={styles.noContentContainer}>
      <Typography sx={styles.noContentHeading}>{heading}</Typography>
      {subheading && <Typography sx={styles.noContentSubheading}>{subheading}</Typography>}
    </Grid>
  );
};
